import { render } from "./PhoneOtp.vue?vue&type=template&id=1fe4b3a2&scoped=true"
import script from "./PhoneOtp.vue?vue&type=script&lang=js"
export * from "./PhoneOtp.vue?vue&type=script&lang=js"

import "./PhoneOtp.vue?vue&type=style&index=0&id=1fe4b3a2&scoped=true&lang=css"
import "./PhoneOtp.vue?vue&type=style&index=1&id=1fe4b3a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe4b3a2"]])

export default __exports__